import React from 'react';
import logo from "../../assets/Logo.svg";

const AppLogo = ({className, width, height}) => {
  return (
    <img style={{
     width,
      height,
    }} className={`${className}`} src={logo} alt='Logo'/>
  );
}

export default AppLogo;
